export const ambulanceRouteDef = [
    {
        path: 'er-connect',
        component: 'ErconnectComponent',
        data: {
            selector: 'app-erconnect',
        }
    },
    {
        path: 'paramedic',
        component: 'ParamedicOrdersComponent',
        data: {
            selector: 'app-paramedic-orders',
        }
    },
    {
        path: 'vital-management',
        component: 'VitalManagementComponent',
        data: {
            selector: 'app-vital-management',
        }
    },
    {
        path: ':resource/add-vitals',
        component: 'VitalsViewComponent',
        data: {
            selector: 'app-vitals-view',
            redirect: true
        }
    },
    {
        path: ':key/emrDesign',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format'
        }
    },
    {
        path: ':resource/addentry',
        component: 'AmbulanceComponent',
        data: {
            action: 'ADD',
            destination: 'service_request',
            selector: 'app-ambulance',
            resource: 'ambulance_approve',
            decorator: 'ambulance_approve'
        }
    },
    {
        path: 'consent_form',
        component: 'ConsentFormComponent',
        data: {
            selector: 'app-consent-form'
        }
    },
    {
        path: 'checklist',
        component: 'AmbulanceComponent',
        data: {
            selector: 'app-ambulance',
            action: 'MODIFY',
            destination: 'checklist'
        }
    },
    {
        path: 'view_checklist',
        component: 'AmbulanceComponent',
        data: {
            selector: 'app-ambulance',
            action: 'VIEW',
            destination: 'checklist'
        }
    },

    {
        path: 'fill_template',
        component: 'EmrTemplateViewComponent',
        data: {
            selector: 'kx-emr-template-view',
            configJson: {
                currentAction:'MODIFY',
                type: 'pcr',
                args: "Patient Care Record",
                showPreviousTemplates: false,
                redirect: true,
                backNavigation: true,
                showTemplateList: false,
                action: 'add',
                params: "",
                customButton: {
                    "Modify": [{
                        "label": "Submit",
                        "action": "final",
                        "icon": "fa fa-check"
                    }]
                },
                dataSrc: {
                    action: 'UPDATE_AMBULANCE_APPROVE',
                    application: 'ambulance-management',
                    resource: 'ambulance_approve'
                }
            }
        }
    },
    {
        path: 'view_template',
        component: 'EmrTemplateViewComponent',
        data: {
            selector: 'kx-emr-template-view',
            configJson: {
                type: 'pcr',
                args: "Patient Care Record",
                showPreviousTemplates: false,
                backNavigation: true,
                showTemplateList: false,
                params: "",
                action: 'view',
                customButton: {
                    "Add": [{
                        "label": "Submit",
                        "action": "final",
                        "icon": "fa fa-check"
                    }]
                },
                dataSrc: {
                    action: 'UPDATE_AMBULANCE_APPROVE',
                    application: 'ambulance-management',
                    resource: 'ambulance_approve'
                }
            }
        }
    },
    {
        path: 'ambulance-settlement',
        component: 'AmbulanceSettlementComponent',
        data: {
            selector: 'app-ambulance-settlement',
        }
    },
    {
        path: 'view_map',
        component: 'ParamedicOrdersComponent',
        data: {
            selector: 'app-paramedic-orders',
            type: 'view_map'
        }
    },
    {
        path: 'view_map_pickup',
        component: 'ParamedicOrdersComponent',
        data: {
            selector: 'app-paramedic-orders',
            type: 'view_map_pickup'
        }
    },
    {
        path: 'ambulance_update/:id/updateentry',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            application: 'ambulance-management',
            resource: 'ambulance_update',
            action: 'MODIFY',
            decorator: 'ambulance_approve'
        }
    },
]       